"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.responsiveService = exports.ResponsiveService = void 0;
var models_1 = require("../models");
var BreakpointService_1 = require("./BreakpointService");
/**
 * Utility service for resolving Responsive objects in response to breakpoint changes.
 */
var ResponsiveService = /** @class */ (function () {
    function ResponsiveService() {
        // PUBLIC METHODS ------------------------------------------------
        var _this = this;
        /**
         * Shortcut method to respond breakpoint changes via a provided mapping (so components don't have to). Will kick off the media query subscription if needed.
         * @prop defn: generic breakpoint mapping or constant to map to a specific object
         * @prop listener: a function to call with the mapped object
         * @returns a string key that you can use to unregsiter the listener or undefined
         */
        this.registerListener = function (defn, listener) {
            return BreakpointService_1.breakpointService.registerListener(function (bp) {
                var resolved = _this.resolve(defn, bp);
                listener(resolved);
            });
        };
        /**
         * Utility method to map a Responsive<T> object to a specific T for a particular breakpoint.
         * @prop r: Responsive object to map
         * @prop b: breakpoint to resolve from
         * @returns mapped object T
         */
        this.resolve = function (r, b) {
            var result = r;
            var mapping = r;
            for (var _i = 0, breakpointMetadata_1 = models_1.breakpointMetadata; _i < breakpointMetadata_1.length; _i++) {
                var meta = breakpointMetadata_1[_i];
                result = mapping[meta.name] !== undefined ? mapping[meta.name] : result;
                if (meta.name === b) {
                    break;
                }
            }
            return result;
        };
    }
    return ResponsiveService;
}());
exports.ResponsiveService = ResponsiveService;
exports.responsiveService = new ResponsiveService();
